import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");

  if (!token || role !== "admin") {
    // Redirect to login if no token is found or user is not an admin
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
